import React, { ReactElement } from 'react';
import { Auth } from 'aws-amplify';
import { SignOutForm } from '../../models/signForm';
import { AuthState } from '@aws-amplify/ui-components';
import { useHistory } from 'react-router-dom';
const SignOut: React.FC<SignOutForm> = ({
  setAuthState,
  setUser,
  setEnvId
}): ReactElement => {
  const history = useHistory();
  Auth.signOut({ global: true }).then(() => {
    localStorage.clear();
    setAuthState(AuthState.SignedOut);
    setUser(undefined);
    setEnvId(undefined);
    history.push('/signin');
  });
  return <></>;
};
export default SignOut;
